import { PaginationQuery, PaginationQueryDefaultValues } from "../pagination/pagination-query";

export interface UsersList {
  id: string,
  userDbId: number,
  name: string,
  username: string,
  roles: string[],
  status: boolean,
  lastActiveDate: string,
  participantPrograms: string[]
}

export function UserListDefaultValues(): UsersList {
  return {
    id: '',
    userDbId: 0,
    name: "",
    username: '',
    roles: [],
    status: false,
    lastActiveDate: '',
    participantPrograms: []
  };
}

export type UserQueryFilter=PaginationQuery & {
  userKeyword: string,
  role: number,
  status: string,
  participantProgram: number,
  programMode?: string
}

export function UserQueryFilterDefaultValues(): UserQueryFilter {
  return{
    ...PaginationQueryDefaultValues(),
    userKeyword: '',
    role: 0,
    status: '',
    participantProgram: 0,
    programMode: ''
  }
}
